import { datadogRum } from '@datadog/browser-rum';

import { VA_FORM_IDS } from 'platform/forms/constants';
import { apiRequest } from 'platform/utilities/api';
import { refreshProfile } from 'platform/user/profile/actions';

// "add-person" service means the user has an EDIPI and SSN in the system, but
// is missing either a BIRLS or participant ID
export const MVI_ADD_NOT_ATTEMPTED = 'MVI_ADD_NOT_ATTEMPTED';
export const MVI_ADD_INITIATED = 'MVI_ADD_INITIATED';
export const MVI_ADD_SUCCEEDED = 'MVI_ADD_SUCCEEDED';
export const MVI_ADD_FAILED = 'MVI_ADD_FAILED';
export const MVI_ADD_REFRESH_FAILED = 'MVI_ADD_REFRESH_FAILED';

export function addPerson(formId = VA_FORM_IDS.FORM_21_526EZ) {
  return async dispatch => {
    dispatch({ type: MVI_ADD_INITIATED });

    let response;
    try {
      response = await apiRequest('/mvi_users/21-0966', { method: 'POST' });
    } catch (error) {
      datadogRum.addError(error, {
        errorType: '526ez-mvi-add-person-post-failed',
        formId,
      });
      dispatch({ type: MVI_ADD_FAILED });
      return;
    }

    dispatch({ type: MVI_ADD_SUCCEEDED, data: response.data });

    // Phase 2: refresh /v0/user so Form526EZApp routes the Veteran into
    // the form (ticket #142609). Refresh failure here does NOT roll back
    // MVI_ADD_SUCCEEDED — POST succeeded; only the refresh failed.
    try {
      await dispatch(refreshProfile(true));
    } catch (refreshError) {
      datadogRum.addError(refreshError, {
        errorType: '526ez-mvi-add-person-refresh-failed',
        formId,
      });
      dispatch({ type: MVI_ADD_REFRESH_FAILED });
    }
  };
}
